/**
 * Tbus transceiver
 * - communication with trolleybuses
 * - part of tbus-switch, separated for use in visuals
 * - used in Pilsen
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'

import Konva from 'konva'

export default class TbusTransceiver extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'transceiver',
        x: 0,
        y: 0,
        width: 350,
        height: 60,
        strokeWidth: 1,
        fill: Color.onlineWhite,
        opacity: 1
      }),

      new Ren.Line({
        points: [0, 20, 350, 20],
        strokeWidth: 1,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [95, 0, 95, 60],
        strokeWidth: 1,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [20, 0, 20, 60],
        strokeWidth: 1,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [0, 40, 350, 40],
        strokeWidth: 1,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [180, 0, 180, 60],
        strokeWidth: 1,
        opacity: 0.8
      }),

      new Ren.Line({
        points: [300, 0, 300, 60],
        strokeWidth: 1,
        opacity: 0.8
      }),

      new Konva.Text({
        x: 25,
        y: 5,
        text: 'Vehicle ID',
        fontSize: 12,
        fill: 'black'
      }),

      new Konva.Text({
        x: 100,
        y: 5,
        text: 'Destination',
        fontSize: 12,
        fill: 'black'
      }),

      new Konva.Text({
        x: 185,
        y: 5,
        text: 'Type',
        fontSize: 12,
        fill: 'black'
      }),

      new Konva.Text({
        x: 305,
        y: 5,
        text: 'Tr. #',
        fontSize: 12,
        fill: 'black'
      }),

      new Konva.Text({
        name: 'vehicleIdPlaceholder',
        x: 25,
        y: 25,
        text: '',
        fontSize: 12,
        fill: 'black'
      }),

      new Konva.Text({
        name: 'destinationPlaceholder',
        x: 100,
        y: 25,
        text: '',
        fontSize: 12,
        fill: 'black'
      }),

      new Konva.Text({
        name: 'typePlaceholder',
        x: 185,
        y: 25,
        text: '',
        fontSize: 12,
        fill: 'black'
      }),

      new Konva.Text({
        name: 'transceiverNumberPlaceholder',
        x: 305,
        y: 25,
        text: '',
        fontSize: 12,
        fill: 'black'
      }),

      new Konva.RegularPolygon({
        name: 'straight',
        x: 10,
        y: 35,
        sides: 3,
        radius: 7,
        scaleY: 1,
        stroke: 'black',
        fill: 'black',
        visible: false
      }),

      new Konva.RegularPolygon({
        name: 'right',
        x: 8,
        y: 30,
        sides: 3,
        radius: 7,
        scaleY: 1,
        stroke: 'black',
        fill: 'black',
        rotation: '90',
        visible: false
      }),

      new Konva.RegularPolygon({
        name: 'left',
        x: 10,
        y: 30,
        sides: 3,
        radius: 7,
        scaleY: 1,
        stroke: 'black',
        fill: 'black',
        rotation: '270',
        visible: false
      }),

      new Konva.Text({
        name: 'directionPlaceholder',
        x: 5,
        y: 25,
        text: '',
        fontSize: 12,
        fill: 'black'
      })
    )
  }

  setTransceiver (status) {
    return new Promise((resolve, reject) => {
      const vehicles = status.vehicleTransit
      // first element is label
      const vehicleId = vehicles[0][1]
      const destination = vehicles[1][1]
      const type = vehicles[2][1]
      const direction = vehicles[3][1]
      const transceiverNumber = vehicles[4][1]

      this.modifyShape('vehicleIdPlaceholder', 'text', vehicleId)
      this.showDirection(direction)
      this.modifyShape('destinationPlaceholder', 'text', destination)
      this.modifyShape('typePlaceholder', 'text', type)
      this.modifyShape('transceiverNumberPlaceholder', 'text', transceiverNumber)
      resolve('Done')
    })
  }

  showDirection (direction) {
    this.modifyShape('straight', 'visible', direction === 'straight')
    this.modifyShape('left', 'visible', direction === 'left')
    this.modifyShape('right', 'visible', direction === 'right')
  }

  applyStatusOnShapes (newVariables, deviceTypes) {
    // online
    const status = newVariables || this.status
    super.applyStatusOnShapes(newVariables)
    if (status.vehicleTransit) {
      this.modifyShape('transceiver', 'fill', Color.onlineWhite)
      this.setTransceiver(status).then(value => {
        // const element = this
        setTimeout(() => {
          // console.log("REMOVE VETRA VALUE")
          // console.log(status.vehicleTransit[2][1])
          this.modifyShape('vehicleIdPlaceholder', 'text', '')
          this.modifyShape('right', 'visible', false)
          this.modifyShape('left', 'visible', false)
          this.modifyShape('straight', 'visible', false)
          this.modifyShape('destinationPlaceholder', 'text', '')
          this.modifyShape('typePlaceholder', 'text', '')
          this.modifyShape('transceiverNumberPlaceholder', 'text', '')
          const layer = this.shapes.find(s => s.attrs.name === 'vehicleIdPlaceholder').getLayer()
          if (layer) {
            layer.batchDraw()
          }
        }, 10000)
      })
      // setTimeout(this.modifyShape('vehicleIdPlaceholder', 'text', 'WHO KNOWS'), 20000)
    }

    if (this.online) {
      this.modifyShape('transceiver', 'fill', Color.onlineWhite)
    }
  }
}
